import { create, StateCreator } from 'zustand';
import { Unionize } from 'utilitys/helpers/TsGeneral';

interface Props {
    isMobile: boolean;
    update: (value: Unionize<Omit<Props, 'update'>>) => void;
}
const state: StateCreator<Props> = (set) => ({
    isMobile: false,
    update: (value) => set({ ...value }),
});
export const useMobileStore = create(state);
